/* ============================================================
   kit-pdp.js — FAQ accordion + Bottom CTA add-to-cart
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ---------- FAQ ACCORDION ---------- */
  var faqItems = document.querySelectorAll('.kit-faq-item');
  
  faqItems.forEach(function(item, idx) {
    var btn = item.querySelector('.kit-faq-q');
    var answer = item.querySelector('.kit-faq-a');
    var chevron = btn.querySelector('.kit-faq-q__chevron');

    // First item open by default
    if (idx === 0) {
      answer.classList.add('kit-faq-a--open');
      chevron.classList.add('kit-faq-q__chevron--open');
    }

    btn.addEventListener('click', function() {
      var isOpen = answer.classList.contains('kit-faq-a--open');

      // Close all
      faqItems.forEach(function(otherItem) {
        otherItem.querySelector('.kit-faq-a').classList.remove('kit-faq-a--open');
        otherItem.querySelector('.kit-faq-q__chevron').classList.remove('kit-faq-q__chevron--open');
      });

      // Toggle clicked (if it wasn't already open)
      if (!isOpen) {
        answer.classList.add('kit-faq-a--open');
        chevron.classList.add('kit-faq-q__chevron--open');
      }
    });
  });

  /* ---------- BOTTOM CTA: ADD TO CART ----------
     Delegates to the hero CRO panel's ATC when possible, so the kit gets
     added WITH all its free gifts (Detox Tracker, custom scoop, eBook, etc.)
     via the existing _bb_gifts / _bb_gift_for line-item-property machinery
     in cro-panel.js. If no CRO panel is on the page (e.g. merchant pasted
     this section onto a non-kit product), or if a manual variant_id
     override was set in section settings that doesn't match the CRO panel,
     we fall back to a plain single-variant /cart/add.js call. */
  var bottomAtcBtn = document.querySelector('.kit-bottom-atc');
  if (!bottomAtcBtn) return;

  bottomAtcBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (bottomAtcBtn.classList.contains('is-loading')) return;
    var btnVariantId = parseInt(bottomAtcBtn.getAttribute('data-variant-id'), 10);

    // Try delegating to the hero CRO panel ATC — it carries gift IDs +
    // bundle ID + qty in its own data-* attributes and routes through
    // cro-panel.js's full gift-aware add-to-cart pipeline.
    var croAtc = document.querySelector('[data-cro-add-to-cart]');
    if (croAtc) {
      var croVariantId = parseInt(croAtc.getAttribute('data-variant-id'), 10);
      // Match check: same product? (Either the bottom CTA used the section's
      // default fallback variant, or merchant typed in the same id manually.)
      if (!btnVariantId || btnVariantId === croVariantId) {
        bottomAtcBtn.classList.add('is-loading');
        croAtc.click();
        // CRO panel dispatches cart:added + bb:cart:open itself on success.
        // Remove our spinner shortly after — CRO panel handles its own.
        setTimeout(function () { bottomAtcBtn.classList.remove('is-loading'); }, 1200);
        return;
      }
    }

    // Fallback: plain add (no gifts). Used when merchant overrode variant
    // to a different product, or the CRO panel isn't on the page.
    if (!btnVariantId) {
      console.warn('[kit-bottom-atc] No variant id resolved — section settings + product context both empty.');
      return;
    }
    bottomAtcBtn.classList.add('is-loading');
    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: btnVariantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            console.error('[kit-bottom-atc] add-to-cart failed:', data);
            throw data;
          }
          return data;
        });
      })
      .then(function (data) {
        bottomAtcBtn.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { response: data } }));
        document.dispatchEvent(new CustomEvent('bb:cart:open'));
      })
      .catch(function (err) {
        bottomAtcBtn.classList.remove('is-loading');
        console.error('[kit-bottom-atc] add-to-cart error:', err);
      });
  });
});
